import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EvaluatedLinkdinService {
  mainURL = 'api/';

  constructor(private http: HttpClient) {}
  getEvaluatedLinkdinProfiles() {
    const token = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    return this.http.get(environment.apiUrl + this.mainURL + 'scan-linkedin', {
      headers: headers,
    });
  }
}
